import { render, staticRenderFns } from "./sup-cardsetting-ewallet.vue?vue&type=template&id=44bdf5aa"
import script from "./sup-cardsetting-ewallet.vue?vue&type=script&lang=js"
export * from "./sup-cardsetting-ewallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports